/** Export contract: exact phase names and numeric/boolean metrics only. */
export const THREAD_TRACE_PHASES: Record<string, readonly [string, readonly string[]]> = {
  'thread-open-start': ['thread.open.start', ['shouldScrollToLatestOnOpen']],
  'thread-open-close': ['thread.open.close', []],
  'thread-open-error': ['thread.open.error', []],
  'thread-open-settled': ['thread.open.settled', ['current']],
  'thread-open-complete': ['thread.open.complete', ['skipNetworkBootstrap']],
  'thread-cache-hydrate-start': ['thread.cache.start', []],
  'thread-cache-hydrate-finished': ['thread.cache.read', ['cacheHit']],
  'thread-cache-hydrate-error': ['thread.cache.error', []],
  'thread-cache-hydrate-applied': [
    'thread.cache.applied',
    [
      'appliedCount',
      'expectedReplyCount',
      'hasMoreBefore',
      'snapshotComplete',
      'relationSnapshotComplete',
      'tailLoaded',
    ],
  ],
  'thread-open-complete-cache-hit': ['thread.cache.complete', ['cachedCount']],
  'thread-sdk-bootstrap-start': ['thread.sdk.start', []],
  'thread-sdk-bootstrap-ready': [
    'thread.sdk.ready',
    ['sdkEventCount', 'rootPresent', 'contextRequested'],
  ],
  'thread-sdk-bootstrap-context-error': ['thread.sdk.context_error', []],
  'thread-sdk-bootstrap-relations-error': ['thread.sdk.relations_error', []],
  'thread-sdk-bootstrap-get-thread-timeline-error': ['thread.sdk.timeline_error', []],
  'thread-sdk-bootstrap-missing-thread-model': ['thread.sdk.missing_model', []],
  'thread-sdk-bootstrap-relations-fallback': [
    'thread.sdk.fallback',
    ['mappedCount', 'nextBatchPresent'],
  ],
  'thread-refresh-latest-start': ['thread.latest.start', []],
  'thread-refresh-latest-complete': [
    'thread.latest.complete',
    ['persistedCount', 'snapshotComplete', 'backwardTokenPresent'],
  ],
  'reconcile-scheduled': ['thread.reconcile.scheduled', []],
  'reconcile-chunk': ['thread.reconcile.chunk', ['iteration', 'chunkSize', 'replyCount']],
  'reconcile-complete': [
    'thread.reconcile.complete',
    ['fetchedCount', 'iterations', 'repaired', 'durable', 'fetchFailedOccurred'],
  ],
  'thread-reconcile-observer': ['thread.reconcile.delivery', ['current', 'mappedCount']],
  'thread-reconcile-settled': [
    'thread.reconcile.settled',
    ['current', 'fetchedCount', 'repaired', 'durable', 'aborted'],
  ],
  'thread-reconcile-error': ['thread.reconcile.error', []],
  'thread-render-scheduler': ['thread.scheduler', ['source', 'delayMs', 'visible']],
  'thread-render-snapshot': [
    'thread.render',
    [
      'eventCount',
      'modelEventCount',
      'modelReplyCount',
      'loadedReplyCount',
      'renderableReplyCount',
      'mountedReplyCount',
      'expectedReplyCount',
      'rootMounted',
      'virtualItemCount',
      'cacheHydrated',
      'sdkReady',
      'loading',
      'loadError',
      'renderAttemptCount',
      'commitCount',
      'attemptedEventCount',
      'attemptedSdkReady',
      'attemptedCacheHydrated',
    ],
  ],
};
